import { useTranslation } from 'react-i18next';
import ControlledTextEditor from '../../../../components/custom-inputs/ControlledTextEditor';
import { TimedProjectEditorMenu } from '../../../../components/editor/menu-option-lists/menu-item-lists';

const Strategy = () => {
  const { t } = useTranslation();

  return (
    <ControlledTextEditor
      label={t('pitches.topLevelStrategy')}
      name="overview.strategy"
      items={TimedProjectEditorMenu}
      required
    />
  );
};

export default Strategy;
